import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';

import styles from './index.css';


const DiscountNotice = (props) => {
  const { isDiscountActive } = props;

  if (!isDiscountActive) {
    return null;
  }

  return (
    <div className={styles.discountNotice}>
      {translate('v2profile.my.shop.sale')}
    </div>
  );
};

DiscountNotice.propTypes = {
  isDiscountActive: PropTypes.bool.isRequired,
};

export default memo(DiscountNotice);
